import { render } from "./SenetWidget.vue?vue&type=template&id=51b06224"
import script from "./SenetWidget.vue?vue&type=script&lang=js"
export * from "./SenetWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__